import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utilities/axiosInstance";
import { filterRequest } from "../../utilities/apiManager";

let initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
}

export const getPoints = createAsyncThunk(
  "points/getPoints",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, query = "", owner, user, filter = {} } = args;
      const filterStr = filterRequest(filter);
      const params = new URLSearchParams();

      // Only add non-empty params
      if (page) params.append("page", page);
      if (size) params.append("size", size);
      if (query) params.append("query", query);
      if (owner) params.append("owner", owner);
      if (user) params.append("user", user);

      const url = `/points${params.toString() ? '?' + params.toString() : ''}${filterStr}`;

      const response = await axiosInstance.get(url);
      const { data: pointsArray, itemsCount, pages } = response.data.data;
      return thunkApi.fulfillWithValue({ data: pointsArray, itemsCount, pages });
    } catch (errors) {
      console.log(errors);
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const createPoint = createAsyncThunk(
  "points/createPoint",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(
        `/points`,
        args
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const getGiftedPoints = createAsyncThunk(
  "points/getGiftedPoints",
  async (args, thunkApi) => {
    try {
      const { page = 1, size = 10, user } = args;
      const params = new URLSearchParams();

      if (page) params.append("page", page);
      if (size) params.append("size", size);
      if (user) params.append("user", user);
      params.append("reason", "GIFT");

      const url = `/points${params.toString() ? '?' + params.toString() : ''}`;

      const response = await axiosInstance.get(url);
      const { data: pointsArray, itemsCount, pages } = response.data.data;
      return thunkApi.fulfillWithValue({ data: pointsArray, itemsCount, pages });
    } catch (errors) {
      console.log(errors);
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const pointsSlice = createSlice({
  name: "points",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getPoints.pending, (state) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(getPoints.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.error = null;
        state.data = payload.data;
        state.itemsCount = payload.itemsCount;
        state.pages = payload.pages;
      })
      .addCase(getPoints.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(createPoint.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createPoint.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data.push(payload.data);
        state.itemsCount++;
        state.error = null;
      })
      .addCase(createPoint.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(getGiftedPoints.pending, (state) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(getGiftedPoints.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.error = null;
        state.data = payload.data;
        state.itemsCount = payload.itemsCount;
        state.pages = payload.pages;
      })
      .addCase(getGiftedPoints.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })
  }
});

export default pointsSlice.reducer;